export default function () {
	jQuery('header .menu li.menu-item-has-children a').click(function(event) {
		if (!jQuery(this).closest('ul').hasClass('sub-menu')) {
			event.preventDefault();
		}
	});
}